import styled from "styled-components";

export const OptInOuterFrameCasino777Box = styled.div`   
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-image: 
        url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_mountains_bg_png.toString()}),
        linear-gradient(transparent, ${props => props.theme.colors.backgroundMiddleDark});

    background-size: 200%;
    background-repeat: no-repeat, no-repeat;
    background-position-y: 80%;
    background-position-x: 44%;

    @media ${({theme}) => theme.mediaQuery.mAndBelow + " and " + theme.mediaQuery.landscape} {
        background-position-y: 67%;
    }
`;
